export type OrNull<T> = T | null;

interface IGetConfigInterface<T> {
  configName: string;
  defaultValue?: T;
  isRequired?: boolean;
}

interface IGetConfigInterfaceWithDefault<T> extends IGetConfigInterface<T> {
  defaultValue: T;
}

interface IGetConfigInterfaceWithRequired<T> extends IGetConfigInterface<T> {
  isRequired: true;
}

function getNestedValue(obj: Record<string, unknown>, path: string): unknown {
  return path.split('.').reduce((current: unknown, key: string) => {
    if (current && typeof current === 'object') {
      return (current as Record<string, unknown>)[key];
    }
    return undefined;
  }, obj);
}

export function getConfig<T>(config: IGetConfigInterfaceWithDefault<T>): T;
export function getConfig<T>(config: IGetConfigInterfaceWithRequired<T>): T;
export function getConfig<T>(config: IGetConfigInterface<T>): OrNull<T>;

export function getConfig<T>(config: IGetConfigInterface<T>): OrNull<T> {
  const appConfig = window.overrides_data;
  if (!appConfig) {
    throw new Error('App configuration is not available.');
  }

  const value = getNestedValue(appConfig as unknown as Record<string, unknown>, config.configName);
  if (value === undefined || value === null) {
    if (config.isRequired) {
      throw new Error(`Config ${config.configName} is required.`);
    }

    return config.defaultValue ?? null;
  }

  return value as unknown as OrNull<T>;
}
